import React from "react";
import AppRouter from "./AppRouter";
import { MsalProvider } from "@azure/msal-react";
import msalInstance from "./utils/msalInstance";
import 'react-loading-skeleton/dist/skeleton.css'
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

const App = () => {
  return (
    <div className="App">
      <MsalProvider instance={msalInstance}>
        <AppRouter />
      </MsalProvider>
    </div>
  );
}

export default App;
